// Derive expected high-school graduation year from current grade.
// A student in grade G during a school year that ends in year Y graduates in
// Y + (12 - G). The school year "rolls over" in summer (July+), so a 9th grader
// entered in July 2026 is in the 2026-27 year (ends 2027) and graduates 2030.
export function gradYearFromGrade(grade: string | number, now: Date = new Date()): number | null {
  const g = parseInt(String(grade), 10);
  if (Number.isNaN(g) || g < 1 || g > 12) return null;
  const schoolYearEnd = now.getMonth() >= 6 ? now.getFullYear() + 1 : now.getFullYear();
  return schoolYearEnd + (12 - g);
}
